import { Button } from "primereact/button";
import React, { useState } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate,useLocation } from "react-router-dom";
import "./style.scss";

const Sidebar = (props) => {
  const userInfo = useSelector((state) => state.redux.userInfo);
  const location = useLocation();

  const isAdminUser = useCallback(() =>{
    return userInfo.isAdmin;
  },[userInfo]);
  const [activeRoute, setActiveRoute] = useState(isAdminUser() ? "users" : "home");
  const navigate = useNavigate();

  useEffect(()=>{
    if(isAdminUser()){
      setActiveRoute("users");
    }
  },[location.pathname,isAdminUser])



  return (
    <div className="sidebar">
      <div className="text-white user-info">Welcome, {userInfo.name}</div>
      <div className="pages my-4">
        {!isAdminUser() && (
          <ul>
            <li className={activeRoute === "home" ? "active" : ""}>
              <Button
                onClick={() => {
                  navigate("/home");
                  setActiveRoute("home");
                }}
                label="Trading"
                icon="pi pi-money-bill"
                className="p-button-sm"
              />
            </li>
            <li className={activeRoute === "my-requests" ? "active" : ""}>
              <Button
                onClick={() => {
                  navigate("/home/my-requests");
                  setActiveRoute("my-requests");
                }}
                label="My Requests"
                icon="pi pi-home"
                className="p-button-sm"
              />
            </li>
            <li className={activeRoute === "profile" ? "active" : ""}>
              <Button
                onClick={() => {
                  navigate("/home/profile");
                  setActiveRoute("profile");
                }}
                label="Profile"
                icon="pi pi-user"
                className="p-button-sm"
              />
            </li>
            <li className={activeRoute === "transactions" ? "active" : ""}>
            <Button
              onClick={() => {navigate("/home/transactions");setActiveRoute("transactions")}}
              label="Transactions"
              icon="pi pi-money-bill"
              className="p-button-sm"
            />
          </li>

          {/* <li className={activeRoute === "courses" ? "active" : ""}>
            <Button
              onClick={() => {navigate("/home/courses");setActiveRoute("courses")}}
              label="Courses"
              icon="pi pi-book"
              className="p-button-sm"
            />
          </li> */}
          </ul>
        )}

        {isAdminUser() && (
          <ul>
            <li className={activeRoute === "users" ? "active" : ""}>
              <Button
                onClick={() => {
                  navigate("/home/users");
                  setActiveRoute("users");
                }}
                label="Users"
                icon="pi pi-users"
                className="p-button-sm"
              />
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
